import React from 'react';
import '../dashboard/Dashboard.css'; // Import the CSS file for styles

const ManagepostbackPage: React.FC = () => {
  return (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif', maxWidth: '100%', margin: 'auto', backgroundColor: '#fff', borderRadius: '8px', boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)' }}>
      <div style={{width:'50%'}}>
      <h2 style={{ color: '#333', marginBottom: '20px', fontSize:'12px' }}>Global Postback Setup:</h2>
      <p style={{ lineHeight: '1.6', color: '#555' }}>
        The BidVertiser Global Postback allows you to link between a certain click and a conversion (sale, signup, lead etc). This valuable information will help you to optimize traffic sources.
      </p>
      <p style={{ lineHeight: '1.6', color: '#555' }}>
        You should configure your affiliate tracking software or your in-house solution to fire the postback URL upon a conversion.
      </p>

      <h3 style={{ color: '#333', marginTop: '20px', marginBottom: '10px', fontSize:'12px', fontWeight:'400'  }}>Available parameters are:</h3>
      <ul style={{ marginLeft: '20px', color: '#555' }}>
        <li style={{fontSize:'12px'}}><strong>{'{BV_CLICKID}'}</strong> - Make sure to tag your ad with this parameter under the "Edit Ad" page</li>
        <li style={{fontSize:'12px'}}><strong>{'{REVENUE}'}</strong> - Represents the revenue of your conversion</li>
      </ul>

      <p style={{ lineHeight: '1.6', color: '#555', fontSize:'12px' }}>
        Please make sure to tag your campaign accordingly so that the <strong>{'{BV_CLICKID}'}</strong> will be sent to your target URL (in order for you to be able to send it back to us using the link below).
      </p>

      <p style={{ lineHeight: '1.6', fontSize:'12px'}}>
        <b style={{ color: '#d9534f',}}>Please note: </b> Postback tracking is meant to track conversions, not pageviews! Do not fire the postback for each pageview on your site as it will lead to postback suspension.
      </p>

      <p style={{ lineHeight: '1.6', color: '#555', fontSize:'12px' }}>
        You can tag your campaign in the "Edit Ad" page (under Manage Campaigns &gt; Actions).
      </p>

      <h3 style={{ color: '#333', marginTop: '20px', marginBottom: '10px', fontSize:'12px' }}>Postback URL:</h3>
      <div style={{  fontSize:'12px', padding: '10px' }}>
        http://secure.bidvertiser.com/performance/pc.dbm?ver=1.0&AID=338336124&CLICKID={"{BV_CLICKID}"}&revenue={"{REVENUE}"}
      </div>

<div style={{textAlign:'center'}}>
<p style={{ marginTop: '20px',fontSize:'12px', fontStyle: 'italic', color: '#555' }}>
        Global Postback activation date: <strong>24-Dec-24</strong>
      </p>
  
</div>
      </div>
      
    </div>
  );
};

export default ManagepostbackPage;
